module.exports = __webpack_public_path__ + "static/media/guide-mobile.823f9f9c.png";